import React from 'react'
import { ContractAndVehicleSelectForm } from './ContractAndVechicleSelectForm'

interface ContractAndVehicleSectionProps {
  description: string
}
export const ContractAndVehicleSection: React.FC<ContractAndVehicleSectionProps> = ({ description }) => {
  return (
    <div id='contract-section'>
      <p>{description}</p>
      <ContractAndVehicleSelectForm />
    </div>
  )
}
